import { Utilities } from './services/utilities';
import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class CustomUrlSerializer extends UrlSerializer {
    /** Parses a url into a {@link UrlTree} */
    private defaultSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

    private get isAuthenticated(): boolean {
        return this.authService.instance.getAllAccounts().length > 0;
    }


    constructor(private authService: MsalService, private localStorageService: LocalStorageService) {
        super();
    }

    parse(url: string): UrlTree {
        if (!this.isAuthenticated) {
            if (!this.localStorageService.retrieve('postlogin_uri')) {
                this.localStorageService.store('postlogin_uri', url);
            }

        } else {
            const postlogin = this.localStorageService.retrieve('postlogin_uri');
            if (postlogin) {
                url = postlogin;
                this.localStorageService.clear('postlogin_uri');
                window.location.href = url;
            }
        }

        url = Utilities.formatBase64Url(url);

        const urlTree = this.defaultSerializer.parse(url);

        return urlTree;
    }



    /** Converts a {@link UrlTree} into a url */
    serialize(tree: UrlTree): string {
        return this.defaultSerializer.serialize(tree);
    }
}
